module.exports = __webpack_public_path__ + "img/Weapon_134.1a8bb5ac.png";